import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Rajeshwari from '../../assets/Rehab staff/Rajeshwari.JPG';
import drvishnu from '../../assets/Rehab staff/drvishnu.jpg';

const teamMembers = [
  {
    name: 'Dr. Vishnu Gade',
    role: 'Director & Chief Physician',
    bio: 'Leading our center with decades of experience in rehabilitation medicine.',
    image: drvishnu,
  },
  {
    name: 'Dr. Rajeshwari',
    role: 'Head of Nursing',
    bio: 'Ensuring compassion and high-quality care for all our patients.',
    image: Rajeshwari,
  },
];

const sections = [
  {
    title: 'Our Services',
    items: [
      { heading: 'Comprehensive Rehabilitation', content: 'Our team provides comprehensive rehabilitation services, including physical therapy, occupational therapy, and speech therapy, to help individuals regain their strength, mobility, and function.' },
      { heading: 'Pain Management', content: 'Our pain management program offers treatments including medication, physical therapy, and alternative therapies.' },
      { heading: 'Wound Care', content: 'Specialized wound care services including dressing changes, debridement, and wound closure.' },
      { heading: 'Orthotics and Prosthetics', content: 'Customized orthotics and prosthetics including fabrication, fitting, and training.' },
      { heading: 'Rehabilitation Nursing', content: 'Specialized nursing care including medication management and wound care.' },
      { heading: 'Physical Therapy', content: 'Improving strength, mobility, and function with exercise and manual therapy.' },
      { heading: 'Occupational Therapy', content: 'Support for daily living activities and vocational rehabilitation.' },
      { heading: 'Speech Therapy', content: 'Treatments including speech, language, and cognitive therapy.' },
      { heading: 'Psychological Services', content: 'Assessment, counseling, and intervention for mental well-being.' },
      { heading: 'Hydrotherapy', content: 'Water-based therapies to improve mobility and healing.' },
      { heading: 'Virtual Rehabilitation', content: 'Tech-enabled therapy from the comfort of your home.' },
    ],
  },
  {
    title: 'Specialized Programs',
    items: [
      { heading: 'Stroke Rehabilitation Program', content: 'Specialized stroke care including PT, OT, and speech therapy.' },
      { heading: 'Spinal Cord Injury Program', content: 'Rehab and training for spinal cord injury recovery.' },
      { heading: 'Traumatic Brain Injury Program', content: 'Therapies for physical and cognitive rehabilitation.' },
      { heading: 'Amputee Rehabilitation Program', content: 'Rehabilitation and prosthetic training for amputees.' },
    ],
  },
];

const MedicalRehabilitation = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (

    <div>
      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Medical Rehabilitation</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Medical Rehabilitation at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            At our esteemed institution, we recognize the importance of comprehensive medical rehabilitation in helping individuals recover from illness, injury, or surgery. Our Department of Medical Rehabilitation is dedicated to providing a range of in-patient and out-patient services, tailored to meet the unique needs of each individual.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering high-quality, patient-centered care. Our team of professionals fosters recovery, independence, and well-being.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To know more about our Department of <strong>Medical Rehabilitation</strong> or to schedule an appointment, click below and fill out our appointment request form.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>

  );
};

export default MedicalRehabilitation;